import React from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { selectTag } from "../../features/filter/filterSlice";
import LikeUnLike from "./LikeUnLike";

const VideoDescription = ({ video }) => {
    const dispatch = useDispatch();
    const { title, description, date, tags } = video || {};
    const location = useLocation();
    const navigate = useNavigate();

    const handleTagSelection = (tag) => {
        dispatch(selectTag(tag));

        if (location.pathname !== "/") {
            navigate("/");
        }
    };

    return (
        <div>
            <div>
                {tags.length > 0 &&
                    tags.map((tag, index) => (
                        <span
                            onClick={() => handleTagSelection(tag)}
                            key={index}
                            className="text-blue-600 cursor-pointer mr-[5px]"
                        >
                            #{tag}
                        </span>
                    ))}
            </div>
            <h1 className="text-lg font-semibold tracking-tight text-slate-800">
                {title}
            </h1>
            <div className="pb-4 flex items-center space-between border-b">
                <h2 className="text-sm leading-[1.7142857] text-slate-600 w-full">
                    Uploaded on {date}
                </h2>

                <LikeUnLike videoInfo={video} />
            </div>

            <div className="mt-4 text-sm text-[#334155] dark:text-slate-400">
                {description}
            </div>
        </div>
    );
};

export default VideoDescription;
